import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBitbot24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M13 4.2a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 12c-.76 0-1.375.613-1.375 1.37h2.75C8.375 12.613 7.759 12 7 12M12 16.5a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2M16.627 12c-.758 0-1.373.615-1.373 1.373H18c0-.758-.615-1.373-1.373-1.373" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M5.76 6.424c3.754-.294 8.653-.294 12.407 0a2.934 2.934 0 0 1 2.642 2.375c.621 3.184.999 5.564 1.115 8.216A2.86 2.86 0 0 1 19.245 20c-4.107.271-10.456.271-14.563 0a2.86 2.86 0 0 1-2.68-2.985c.118-2.652.495-5.032 1.116-8.216A2.934 2.934 0 0 1 5.76 6.424m12.25 1.993c-3.65-.285-8.443-.285-12.094 0a.935.935 0 0 0-.835.765c-.615 3.151-.97 5.418-1.08 7.921-.02.472.334.87.812.901 4.02.265 10.28.265 14.3 0a.86.86 0 0 0 .813-.9c-.11-2.504-.465-4.77-1.08-7.922a.934.934 0 0 0-.835-.765",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconBitbot24);
export default ForwardRef;
